// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"51cbd47c","326":"9f0f1755","390":"27785931","435":"d72f709b","631":"e3288b49","794":"5d726a7e"}[chunkId] + ".chunk.css";
};